import fetch from 'isomorphic-fetch';
import Config from '../../config/';
import language from '../../../components/locales';
import { detect } from 'detect-browser';
const browser = detect();

const API = {
  data: {
    async getAll(obj) {
      let response = await fetch(
        `${Config.api}/api/accountuser/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },

    async getCount(obj) {
      let response = await fetch(
        `/api/accountuserCount/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async getRoll(obj) {
      let response = await fetch(
        `/api/accountuserRoll/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async getOptionsToCreateUser() {
      let response = await fetch(
        `/api/accountuseroptionstocreateuser`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async getUserToEdit(obj) {
      let response = await fetch(`/api/accountuserusertoedit/${JSON.stringify(obj)}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async handleUser(item) {
      const response = await fetch(`/api/accountuser`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Pragma: 'no-cache'
        }),
        body: JSON.stringify(item)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleUpdateUser(item) {
      const response = await fetch(`/api/accountuser`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }),
        body: JSON.stringify(item)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleUpdateUserPass(item) {
      const response = await fetch(`/api/accountuserPass/${item.id}`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }),
        body: JSON.stringify(item.user)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleDeleteUser(obj) {
      const response = await fetch(`/api/accountuser/${JSON.stringify(obj)}`, {
        method: 'DELETE'
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleActiveUser(obj) {
      const response = await fetch(`/api/accountuser/${JSON.stringify(obj)}`, {
        method: 'PATCH'
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleUserDownload() {
      let response = await fetch(`/api/accountuserFile`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({
          Pragma: 'no-cache'
        })
      });
      var filename = `${language.account.createUser.downloadFileName}.xlsx`;
      const status = response.status;
      const blob = await response.blob();
      var a = document.createElement('a');
      if (browser.name == 'ie') {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        a.setAttribute('href', window.URL.createObjectURL(blob));
        a.setAttribute('target', '_blank');
        a.setAttribute('download', filename);
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      return {
        data: 'ok',
        status: status
      };
    },
    async handleUserUpload() {
      const fullPath = document.getElementById('file').files;
      let formData = new FormData();
      formData.append('file', fullPath[0]);
      const response = await fetch(`/api/accountuserFile`, {
        method: 'POST',
        body: formData,
        headers: new Headers({
          Pragma: 'no-cache'
        })
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async handleUserDownloadAssociateUsers() {
      let response = await fetch(`/api/accountuserFileAssociateUsers`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({
          Pragma: 'no-cache'
        })
      });

      const status = response.status;

      if (status === 200) {
        var filename = `${language.account.modalDriver.downloadFileNameAssociateUsers}.xlsx`;
        const blob = await response.blob();
        var a = document.createElement('a');
        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', filename);
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        return {
          data: 'ok',
          status: status
        };
      } else {
        const data = await response.json();
        return { data, status };
      }
    },
    async handleUserUploadAssociateUsers() {
      let operationResult;
      const fullPath = document.getElementById('file-associate-users').files;
      let formData = new FormData();
      formData.append('file', fullPath[0]);
      const response = await fetch(`/api/accountuserFileAssociateUsers`, {
        method: 'POST',
        body: formData,
        headers: new Headers({
          Pragma: 'no-cache'
        })
      });

      const status = response.status;

      if (status === 200) {
        var filename = `${language.account.modalDriver.downloadFileNameResultAssociateUsers}.xlsx`;
        const blob = await response.blob();
        var a = document.createElement('a');
        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', filename);
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

        try {
          operationResult = JSON.parse(response.headers.get('operation-status'));
        } catch (error) {
          operationResult = 'ok';
        }

        return {
          data: operationResult,
          status: status
        };
      } else {
        const data = await response.json();
        return { data, status };
      }
    },
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/account_user/api/index.js